module.exports = __webpack_public_path__ + "static/media/screenshot.22b32b05.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Device/devices/SchweizerIllustrierteShowcaseBrowser/screenshot.jpg
// module id = 219
// module chunks = 0